import "./Modal.scss"

const Modal = (props) => {
    return (
        <div className='modal-container'>
            <div className="modal-wrapper">
                {props.children}
            </div>
        </div>
    )
}

export default Modal